/**
 * Once-ever flag for the review-app prompt (specs/review-prompt).
 * Marked when the prompt is SHOWN (not on button press) so a user is never asked twice.
 * Read failures return false (never seen) — worst case is one extra showing, never a crash.
 */

import { Platform } from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { logger } from '../../helpers/logger.helper';

const key = (userId: string) => `has_seen_review_prompt_${userId}`;

export async function hasSeenReviewPrompt(userId: string): Promise<boolean> {
  try {
    if (Platform.OS === 'web' && typeof window !== 'undefined') {
      return localStorage.getItem(key(userId)) === 'true';
    }
    const value = await AsyncStorage.getItem(key(userId));
    return value === 'true';
  } catch (error) {
    if (__DEV__) logger.warn('reviewPromptSeen: read failed', { error });
    return false;
  }
}

export async function markReviewPromptSeen(userId: string): Promise<void> {
  try {
    if (Platform.OS === 'web' && typeof window !== 'undefined') {
      localStorage.setItem(key(userId), 'true');
      return;
    }
    await AsyncStorage.setItem(key(userId), 'true');
  } catch (error) {
    if (__DEV__) logger.warn('reviewPromptSeen: write failed', { error });
  }
}
